import type {
  ExpectedReceipt,
  ExpectedReceiptInput,
  PostReceiptResult,
  ReceiptCount,
} from '../domain/goods-intake';
import { goodsIntakeApi as liveGoodsIntakeApi } from './live-goods-intake-api';
import { goodsIntakeApi as mockGoodsIntakeApi } from './mock-goods-intake-api';

export interface ReceiptFilters {
  siteId?: string | undefined;
  openOnly?: boolean | undefined;
}

/**
 * Expected receipts and Goods Intake, backed by leatherback's StockService
 * (tidaltech/koi#8100). The mock posts into the shared mock stock ledger, so
 * received stock shows up on the Stock page and can be picked.
 */
export interface GoodsIntakeApi {
  listReceipts(filters?: ReceiptFilters): Promise<ExpectedReceipt[]>;
  getReceipt(id: string): Promise<ExpectedReceipt>;
  /** Open receipts a scanned parcel, pallet, shipment or supplier reference belongs to. */
  findReceipts(code: string): Promise<ExpectedReceipt[]>;
  createReceipt(input: ExpectedReceiptInput): Promise<ExpectedReceipt>;
  recordIntake(id: string, version: number, counts: ReceiptCount[]): Promise<ExpectedReceipt>;
  /** Safe to retry: posting a posted receipt returns it with replayed=true. */
  postReceipt(id: string, version: number): Promise<PostReceiptResult>;
  cancelReceipt(id: string, version: number, reason: string): Promise<ExpectedReceipt>;
}

export const goodsIntakeApi: GoodsIntakeApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveGoodsIntakeApi : mockGoodsIntakeApi;
